import React, { useCallback, useMemo, useState } from "react";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { Reminder } from "../../redux/alerts";
import { SubActivityType } from "../../redux/residentActivityPlan";
import { IAppState } from "../../redux/types";
import { Dispatcher } from "../../service/RootDispather";
import { AvatarResidentUser } from "../common/AvatarUser";
import { OverflowTip, RoomBedDisplayByMin } from "../common/Common";
// import "./styles.scss";
import { residentsCreator } from "../../redux/residents/selectors";
import { ModalTypes } from "../status/Callbacks";
import VitalSignsWrap, { saveData, validateValues } from "./VitalSignsWrap";

const VitalSign = ({
  callback,
  residentId,
  reminder,
}: {
  callback: (...params: any) => void;
  residentId: string;
  reminder: Reminder;
}): JSX.Element => {
  const ResidentSelection = useMemo(() => residentsCreator(), []);
  const resident = useSelector((state: IAppState) =>
    ResidentSelection(state, residentId)
  );
  const [vitalSignParams, setvitalSignParams] = useState<saveData[]>(
    reminder?.activityParams.map((el) => {
      return { key: el, value: "" };
    })
  );
  const [errorParams, seterrorParams] = useState(
    Object.values(SubActivityType).map((el) => "")
  );
  const tStatus = useTranslation("status").t;
  const tCommon = useTranslation("common").t;
  const rootDispatcher = Dispatcher();

  const onConfirmEdit = useCallback(() => {
    const valid = validateValues(vitalSignParams);
    if (valid.every((el) => el === "")) {
      const values = {};
      vitalSignParams
        .filter(
          (el) => el.value !== null && el.value !== undefined && el.value !== ""
        )
        .map((el: saveData) => {
          values[el.key as SubActivityType] = el.value;
          return null;
        });
      rootDispatcher.sendResidentActivity({
        residentId: residentId,
        activityType: reminder.activityType,
        activityParams: vitalSignParams
          .filter(
            (el) =>
              el.value !== null && el.value !== undefined && el.value !== ""
          )
          .map((el: saveData) => {
            return el.key.toString();
            // return { [el.key as SubActivityType]: parseInt(el.value) };
          }),
        feedback: {
          values: values,
        },
      });
      callback(ModalTypes.BACK);
    } else seterrorParams(valid);
  }, [callback, residentId, rootDispatcher, reminder, vitalSignParams]);

  const onCloseHandler = useCallback(() => {
    callback(ModalTypes.BACK);
  }, [callback]);
  const onSaveParams = useCallback((values: saveData[]) => {
    setvitalSignParams(values);
  }, []);
  console.log(errorParams);
  return (
    <div className={`modal-sm feedback-modal mobile`}>
      <div className="flex-column flex-column-24">
        <div className="flex-center flex-column">
          <div className="flex-gap  flex-gap-8">
            <AvatarResidentUser profile={resident} size={"24"} />
            <RoomBedDisplayByMin
              devicesMinimized={resident?.devicesMinimized}
            />
          </div>
          <OverflowTip
            text={`${resident.firstName} ${resident.lastName}`}
            className="center"
          />
          <span>{tStatus("feedback")}</span>
        </div>

        <div
          className="flex-gap flex-gap-8"
          style={{
            justifyContent: "center",
            marginTop: "10px",
            marginBottom: "10px",
          }}
        >
          <div className="alert-32">
            <i
              className={`icon-alert info icon-action-${reminder.activityType}`}
            />
          </div>
          <p>{tCommon("activities." + reminder.activityType)}</p>
        </div>
        <div
          className={`vitals-signs`}
          // style={{
          //   border: errorParams.length > 0 ? "border: 1px solid #E85658" : "",
          //   background: errorParams.length > 0 ? "black" : "",
          // }}
        >
          <VitalSignsWrap
            params={reminder?.activityParams}
            onSave={onSaveParams}
            errorObj={errorParams}
          />
        </div>
        <div className="flex-column flex-column-8">
          <button
            style={{ marginTop: "10px" }}
            className="btn primary with-icon full-width save-view"
            onClick={onConfirmEdit}
          >
            <i className="icon-feedback-done" />
            {tCommon("buttons.Save")}
          </button>
          <button
            style={{ marginTop: "10px" }}
            className="btn  with-icon full-width save-view"
            onClick={onCloseHandler}
          >
            <i className="icon-close" />
            {tStatus("buttons.Cancel")}
          </button>
        </div>
      </div>
    </div>
  );
};

export default React.memo(VitalSign);
